import React from 'react';
import { connect } from 'react-redux';

import Autocomplete from 'react-autocomplete';
import { Button, Form, Modal } from 'react-bootstrap';

import throttle from '../../util/throttle';
import { setError } from '../../modules/App/ErrorsActions';
import { selectDashboard } from '../DashboardSelector/DashboardSelectorActions';
import * as BECaller from '../../util/apiCaller';

import Close from '../../assets/img/close.svg';
import saveIcon from '../../assets/img/save.svg';

import './modals.scss';


class SaveDashboardView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpened: props.visible,
      name: '',
      q: '',
      views: [],
      total: 0,
      loading: false
    };

    this.search = throttle(this._search, 500, this);
  }

  _search = () => {
    this.setState({
      loading: true
    });
    BECaller.api(
      `dashboards/${this.props.dashboard._id}/views${!!this.state.q ? `?q=${this.state.q}` : ''}`,
      'get'
    ).then(
      res => {
        //res.data.push({ _id: 'new', name: 'Create new' });
        this.setState({
          views: res.data,
          total: res.total,
          loading: false
        });
      },
      err => {
        this.props.setError(err);
      }
    );
  };

  handleSearch = e => {
    this.setState({ q: e.target.value }, () => {
      this.search(this.state.q);
    });
  };

  onButtonClick = () => {
    if (!this.state.isOpened) {
      this.setState({
        isOpened: true,
        name: '',
        q: '',
        selectedView: null
      });

      this.search();
    }
  };

  onClose = event => {
    if (event) {
      event.stopPropagation();
    }

    this.setState({
      isOpened: false
    });
  };

  _saveNew = () => {
    if (!this.state.name) {
      this.props.setError('Please enter Dashboard View name');
      return null;
    }

    return {
      name: this.state.name,
      saveDatesRange: true,
      overwrite: false
    };
  };

  _saveExisting = () => {
    if (!this.state.selectedView) {
      this.props.setError('Please select Dashboard View to overwrite');
      return null;
    }

    return {
      selectedView: this.state.selectedView,
      saveDatesRange: true,
      overwrite: true
    };
  };

  onConfirm = () => {
    let model;
    if (this.state.selectedView && this.state.selectedView !== 'new') {
      model = this._saveExisting();
    } else {
      model = this._saveNew();
    }
    if (!model) {
      return false;
    }

    this.setState({
      isOpened: false
    });

    BECaller.api(`dashboards/${this.props.dashboard._id}/views/`, 'post', model).then(
      res => {
        this.props.update({
          ...this.props.dashboard,
          selectedView: res.id
        });
      },
      err => {
        this.setState({
          isOpened: true
        });
        this.props.setError(err);
      }
    );
  };

  render() {
    var modal = (
      <Modal show={this.state.isOpened} onHide={this.onClose} className='modal-dashboard-view'>
        <Modal.Header>
          <Modal.Title>Save current dashboard view</Modal.Title>
          <Button variant="close" onClick={this.onClose}>
            <img src={Close} alt="close" />
          </Button>
        </Modal.Header>
        <Modal.Body>
          <div className='dashboard-view'>
            <Form.Group controlId="lastName">
              <div className='dashboard-view-form-wrap'>
                <Form.Label>Dashboard view name (available for all users)</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={this.state.name}
                  onChange={e => this.setState({ name: e.target.value })}
                  placeholder="Add view name here"
                />
              </div>

              <Form.Label className='label-view'>or overwrite existing view</Form.Label>
              <div className='dashboard-view-form-wrap'>
                <div className='search-wrap'>
                  <Form.Control 
                    type="text" 
                    name="q"  
                    value={this.state.q} 
                    onChange={this.handleSearch} 
                    placeholder='Search Dashboard View' />
                </div>
              
                {!!this.state.views.length && (
                  <div className="dashboard-view-list">
                    {this.state.views.map((v, i) => {
                      return (
                        <div
                          key={i}
                          className={`dashboard-view-item ${(v._id === this.state.selectedView) ? 'selected' : ''}`}
                          onClick={() => this.setState({ selectedView: v._id })}
                        >
                          <span className='dashboard-view-name'>{v.name}</span>
                        </div>
                      );
                    })}
                  </div>
                )}

                {!!this.state.loadingViews && <div className='no-results'>Loading...</div>}
              </div>
            </Form.Group>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => this.onConfirm()}>
            <img src={saveIcon} alt='' />
            Save
          </Button>
          <Button variant="secondary"  onClick={this.onClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );

    var content;
    if (this.props.children) {
      var btn = React.Children.only(this.props.children);
      content = React.cloneElement(
        btn,
        {
          onClick: this.onButtonClick,
          style: this.props.style
        },
        btn.props.children,
        modal
      );
    } else {
      content = (
        <Button onClick={this.onButtonClick} style={this.props.style}>
          {this.props.buttonText}
          {modal}
        </Button>
      );
    }

    return content;
  }
}

const mapDispatchToProps = dispatch => {
  return {
    update: d => dispatch(selectDashboard(d)),
    setError: err => dispatch(setError(err))
  };
};

const mapStateToProps = state => {
  return {
    dashboard: state.dashboards.selected
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SaveDashboardView);
